export const DISPLAY_NAME_MIN_LENGTH = 2;
export const DISPLAY_NAME_MAX_LENGTH = 30;
const LEGACY_DISPLAY_NAME_MAX_LENGTH = 32;

const DISPLAY_NAME_PATTERN = /^[\p{L}]+(?:-[\p{L}]+)*$/u;

export const DISPLAY_NAME_TOOLTIP =
  "2 à 30 lettres (accents compris). Un tiret est permis (Marie-Charlotte). Pas de chiffre, ni d'espace, ni d'autre signe. Chaque nom ne peut être choisi qu'une seule fois.";

export function sanitizeDisplayName(value) {
  return String(value || "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, LEGACY_DISPLAY_NAME_MAX_LENGTH);
}

export function normalizeDisplayNameKey(value) {
  return sanitizeDisplayName(value).toLocaleLowerCase("fr-FR");
}

export function validateDisplayName(value) {
  const raw = String(value || "");
  if (!raw) {
    return { ok: false, message: "Indiquez un nom." };
  }
  if (/\s/.test(raw)) {
    return { ok: false, message: "Le nom ne peut pas contenir d'espace." };
  }
  if (raw.length < DISPLAY_NAME_MIN_LENGTH) {
    return {
      ok: false,
      message: `Le nom doit compter au moins ${DISPLAY_NAME_MIN_LENGTH} lettres.`,
    };
  }
  if (raw.length > DISPLAY_NAME_MAX_LENGTH) {
    return {
      ok: false,
      message: `Le nom ne peut pas dépasser ${DISPLAY_NAME_MAX_LENGTH} caractères.`,
    };
  }
  if (!DISPLAY_NAME_PATTERN.test(raw)) {
    return {
      ok: false,
      message:
        "Le nom ne peut contenir que des lettres (accents compris) et un tiret.",
    };
  }
  return {
    ok: true,
    value: raw,
    key: raw.toLocaleLowerCase("fr-FR"),
  };
}
